import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControl, } from '@tribeplatform/react-ui-kit/FormControl';
export const InputCopy = forwardRef(({ name, validation, ...rest }, ref) => {
    const { register, formState } = useFormContext();
    // This is to get the nested errors from formState.errors
    // Example: name = "a.b", we want to get formState.errors.a.b
    const error = name
        .split('.')
        .reduce((error, name) => error === null || error === void 0 ? void 0 : error[name], formState.errors);
    const { ref: registerRef, ...registerRest } = register(name, validation);
    return (_jsx(FormControl.InputCopy, { ref: node => {
            if (ref) {
                ;
                ref.current = node;
            }
            registerRef(node);
        }, name: name, invalid: !!(error === null || error === void 0 ? void 0 : error.message), error: error === null || error === void 0 ? void 0 : error.message, ...registerRest, ...rest }, void 0));
});
//# sourceMappingURL=InputCopy.js.map